import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { ExportHistoryEntry } from '../../models'

@Component({
    selector: 'ach-export-history',
    standalone: true,
    imports: [DatePipe],
    templateUrl: './export-history.component.html',
    styleUrl: './export-history.component.scss',
})
export class ExportHistoryComponent {
    @Input({ required: true }) exportHistory: ExportHistoryEntry[] = []

    get sortedExportHistory(): ExportHistoryEntry[] {
        return [...this.exportHistory].sort((a, b) =>
            new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
        )
    }
}
